import api from "../services/api";
import {
  UserBalanceDTO,
  BalanceTransactionDTO,
  ReviewTopUpDTO,
  AdminAdjustBalanceDTO,
} from "../models/IBalance";

export const getUserBalance = (userId: string): Promise<{ data: UserBalanceDTO }> =>
  api.get(`balance/${userId}`);

export const getUserTransactions = (userId: string): Promise<{ data: BalanceTransactionDTO[] }> =>
  api.get(`balance/${userId}/transactions`);

export const getPendingTopUps = (): Promise<{ data: BalanceTransactionDTO[] }> =>
  api.get("balance/top-ups/pending");

export const reviewTopUp = (dto: ReviewTopUpDTO): Promise<{ data: BalanceTransactionDTO }> =>
  api.post("balance/top-ups/review", dto);

export const adjustBalance = (dto: AdminAdjustBalanceDTO): Promise<{ data: BalanceTransactionDTO }> =>
  api.post("balance/adjust", dto);
